import { useCallback, useEffect, useState } from 'react';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { IMapV2 } from 'types/location.js';

export type SetMapArgs = { mapSlotModules: IModuleConfig[] | undefined };
export type SetMapSlot = (a?: Partial<SetMapArgs> | undefined) => void;

/** We do this so we can easily navigate to where map slots are rendered, cleared */
export const MAP_SLOT_EMPTY = [];
/**
 * Top level management map slots
 * Managed by map layouts (warning and normal maps)
 * Manages slots that are applied from map data
 */
export const MapSlots = ({ mapConfig }: { mapConfig: IMapV2 | undefined }) => {
  const [mapSlot, _setMapSlot] = useState<IModuleConfig[]>();

  /** Add Some MiddleWare HERE TO ADD STUFF FROM LAYOUT CONFIG To IMdodule Config */

  /**
   * Map Slot Initialises with map default modules, updates with any array passed to it, including empty array
   * If want to display default then pass undefined
   */
  const setMapSlot = useCallback(({ mapSlotModules }: Partial<SetMapArgs> = {}) => {
    if (mapSlotModules?.length) {
      const obj = mapSlotModules;
      _setMapSlot(obj);
    } else {
      _setMapSlot(undefined);
    }
  }, []);

  // Whenever mapConfig changes reset so mapSlots do not carry over different pages
  useEffect(() => {
    setMapSlot({ mapSlotModules: mapConfig?.modules });
  }, [mapConfig]);

  /** When layout changes clear map slots */
  useEffect(() => {
    setMapSlot();
    return () => setMapSlot();
  }, [setMapSlot]);

  useEffect(() => {
    if (mapConfig && !mapSlot) {
      setMapSlot({ mapSlotModules: mapConfig?.modules });
    }
  }, [mapSlot, setMapSlot]);

  return [mapSlot, setMapSlot] as const;
};
